var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-switch',{staticClass:"mt-0 mr-8",attrs:{"label":"i18n","ripple":false,"hide-details":""},model:{value:(_setup.i18nEnabled),callback:function ($$v) {_setup.i18nEnabled=$$v},expression:"i18nEnabled"}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }